/** Strings owned by `src/manage/overview/` — "Beheer › Overzicht"
 * (PLAN-FASE3.md WP-05): the platform-staff-only KPI overview. No NPS or
 * AI-summary card — out of scope, see AdminOverviewPage.tsx. */
export const manageOverview = {
  page: {
    title: 'Επισκόπηση',
    lead: 'Βασικά στοιχεία πλατφόρμας: έσοδα, ενεργές εταιρείες και χρήστες, και διατήρηση.',
    activeCompanies: 'Ενεργές εταιρείες',
    activeUsers: 'Ενεργοί χρήστες',
    revenueThisMonth: 'Έσοδα αυτού του μήνα',
    retention: 'Διατήρηση (μήνα προς μήνα)',
    retentionUnavailable: 'Δεν υπάρχουν ακόμη δεδομένα',
    retentionDetail: '{{retained}} από {{total}} εταιρείες διατηρήθηκαν',
  },
} as const;
